const STORY_IMG =
  "https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20vintage%20single%20moving%20truck%20parked%20on%20a%20brooklyn%20street%20in%20year%202007%20painterly%20texture%20nostalgic%20warm%20earth%20tones%20cream%20and%20rust%20palette%20artistic%20cinematic%20composition%20founding%20moment%20moving%20company%20aesthetic%20with%20soft%20directional%20warm%20golden%20morning%20light%20and%20long%20soft%20shadows&width=1200&height=1500&seq=about-story&orientation=portrait";

const milestones = [
  { year: "2007", title: "One truck, two movers", desc: "Founder Sofía Mendoza buys a 16-foot box truck and books her first job through a Craigslist ad. Profit: $84." },
  { year: "2011", title: "First warehouse", desc: "Opens a 12,000 sqft facility in Bushwick. Storage division launches. Crew grows to 8." },
  { year: "2016", title: "Long distance fleet", desc: "Adds three dedicated 26-foot trucks for cross-country moves. Coverage expands to all 48 states." },
  { year: "2020", title: "Pandemic pivot", desc: "Built contactless moving protocols overnight. Kept every employee on payroll. Came out stronger." },
  { year: "2024", title: "Hit 10,000 moves", desc: "Celebrated with a paid week off for every crew member and a barbecue that ran out of brisket." },
  { year: "2026", title: "Where we are today", desc: "38 full-time crew, 7 trucks, 32 cities served, and an obsession with on-time arrivals that borders on unhealthy." },
];

export default function StorySection() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5 lg:sticky lg:top-24 lg:self-start">
            <div className="text-xs uppercase tracking-[0.18em] text-brand-600 font-bold mb-3">
              Our story
            </div>
            <h4 className="font-display text-3xl md:text-5xl font-bold text-ink-900 leading-tight tracking-tight mb-6">
              <a href="#story" className="text-ink-900 hover:text-ink-900 no-underline">
                A 19-year overnight success.
              </a>
            </h4>
            <p className="text-base text-ink-600 leading-relaxed mb-8">
              Haulmark wasn't supposed to be a company. Sofía was a logistics coordinator who got tired of seeing friends overcharged and ghosted by sketchy movers. She borrowed money from her dad, bought a truck, and posted a flyer.
            </p>
            <div className="rounded-2xl overflow-hidden h-[300px] md:h-[420px]">
              <img src={STORY_IMG} alt="Haulmark's first moving truck" className="w-full h-full object-cover object-top" />
            </div>
          </div>

          <div id="story" className="lg:col-span-7">
            <div className="relative">
              <div className="absolute left-[19px] top-2 bottom-2 w-px bg-ink-200" aria-hidden="true"></div>
              <ul className="space-y-9">
                {milestones.map((m) => (
                  <li key={m.year} className="relative pl-14">
                    <span className="absolute left-0 top-1 w-10 h-10 flex items-center justify-center rounded-full bg-brand-500 text-white text-[10px] font-bold ring-4 ring-white">
                      {m.year}
                    </span>
                    <h3 className="font-display text-xl md:text-2xl font-bold text-ink-900 mb-2">
                      {m.title}
                    </h3>
                    <p className="text-sm md:text-base text-ink-600 leading-relaxed">{m.desc}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}